import {
  Required,
  IsString,
  DataValidator,
  transformKeys,
} from "@/utils/type-vaildator";
import api from "./api";

// 原始接口
export interface updateArticleHeaderDrainageByAppResponse {
  success: string;
};

export class UpdateArticleHeaderDrainageByAppData {
  // @Required("Success message cannot be empty")
  @IsString("Success message must be a string")
  success: string;
}

const transformAndValidateAgent = (
  response: updateArticleHeaderDrainageByAppResponse
): UpdateArticleHeaderDrainageByAppData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, UpdateArticleHeaderDrainageByAppData);
  } catch (error) {
    console.error("UpdateArticleHeaderDrainageByApp data validation failed:", error.message);
    throw error;
  }
};

/** 更新 Agent 文章设置（页眉,底图） */
export const updateArticleHeaderDrainageByApp = async ({
  agentId,
  articleHeaderCopy,
  articleDrainageImage,
}: {
  agentId: string,
  articleHeaderCopy: string,
  articleDrainageImage: string
}): Promise<UpdateArticleHeaderDrainageByAppData> => {
  const response = await api.post<updateArticleHeaderDrainageByAppResponse>('/push_info_user_subscription_setting/update-article-header-drainage-by-app', {
    agent_id: agentId,
    article_header_copy: articleHeaderCopy,
    article_drainage_image: articleDrainageImage,
  });
  const data = transformAndValidateAgent(response.data);
  return data;
};
